/**
 * Collection Page JavaScript
 * Untamed v2.1 - Collection Section
 * Handles filter drawer, sorting, and pagination
 */

(function() {
  'use strict';

  // ===== Filter Drawer =====
  const filterDrawer = document.getElementById('filter-drawer');
  const filterBackdrop = document.getElementById('filter-backdrop');
  const filterToggle = document.getElementById('filter-toggle');
  const filterClose = document.getElementById('filter-close');
  const filterApply = document.getElementById('filter-apply');
  const filterClear = document.getElementById('filter-clear');

  function openFilterDrawer() {
    if (!filterDrawer || !filterBackdrop) return;
    
    filterDrawer.classList.add('is-open');
    filterBackdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    
    // GSAP animation if available
    if (typeof gsap !== 'undefined') {
      gsap.fromTo(filterDrawer, 
        { x: '100%' },
        { x: '0%', duration: 0.3, ease: 'power2.out' }
      );
      gsap.fromTo(filterBackdrop,
        { opacity: 0 },
        { opacity: 1, duration: 0.3, ease: 'power2.out' }
      );
    }
  }

  function closeFilterDrawer() {
    if (!filterDrawer || !filterBackdrop) return;
    
    if (typeof gsap !== 'undefined') {
      gsap.to(filterDrawer, { 
        x: '100%', 
        duration: 0.25, 
        ease: 'power2.in',
        onComplete: () => {
          filterDrawer.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      });
      gsap.to(filterBackdrop, { 
        opacity: 0, 
        duration: 0.25, 
        ease: 'power2.in',
        onComplete: () => {
          filterBackdrop.classList.remove('is-open');
        }
      });
    } else {
      filterDrawer.classList.remove('is-open');
      filterBackdrop.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  // Event listeners
  filterToggle?.addEventListener('click', openFilterDrawer);
  filterClose?.addEventListener('click', closeFilterDrawer);
  filterBackdrop?.addEventListener('click', closeFilterDrawer);

  // Close on escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && filterDrawer?.classList.contains('is-open')) {
      closeFilterDrawer();
    }
  });

  // ===== Filter Form Handling =====
  const filterForm = document.getElementById('filter-form');
  
  // chnaged by mokshes shah on 11 august, filter and sorting was not working
  // function getActiveFilters() {
  //   const url = new URL(window.location);
  //   const filters = {};
    
  //   // Parse filter params
  //   for (const [key, value] of url.searchParams) {
  //     if (key.startsWith('filter.')) {
  //       const filterKey = key.replace('filter.', '');
  //       if (!filters[filterKey]) {
  //         filters[filterKey] = [];
  //       }
  //       filters[filterKey].push(value);
  //     }
  //   }
    
  //   return filters;
  // }

  function getActiveFilters() {
    const url = new URL(window.location);
    const filters = {};

    for (const [key, value] of url.searchParams) {
      if (key.startsWith('filter.')) {
        if (!filters[key]) {
          filters[key] = [];
        }

        filters[key].push(value);
      }
    }

    return filters;
  }

  function buildFilterUrl(filters) {
    const url = new URL(window.location);
    
    // Remove all existing filter params
    const keysToDelete = [];
    for (const key of url.searchParams.keys()) {
      if (key.startsWith('filter.')) {
        keysToDelete.push(key);
      }
    }
    keysToDelete.forEach(key => url.searchParams.delete(key));
    
    // Add new filter params
    // for (const [key, values] of Object.entries(filters)) {
    //   values.forEach(value => {
    //     url.searchParams.append(`filter.${key}`, value);
    //   });
    // }
    // chnaged by mokshes shah on 11 august, filter and sorting was not working
    for (const [key, values] of Object.entries(filters)) {
      values.forEach(value => {
        url.searchParams.append(key, value);
      });
    }
    
    // Reset to page 1 when filtering
    url.searchParams.delete('page');
    
    return url.toString();
  }

  // Apply filters
  filterApply?.addEventListener('click', () => {
    const form = document.getElementById('filter-form');
    if (!form) return;
    
    const filters = {};
    const formData = new FormData(form);
    
    for (const [key, value] of formData) {
      if (value) {
        if (!filters[key]) {
          filters[key] = [];
        }
        filters[key].push(value);
      }
    }
    
    window.location = buildFilterUrl(filters);
  });

  // Clear all filters
  filterClear?.addEventListener('click', () => {
    const url = new URL(window.location);
    
    // Remove all filter params
    const keysToDelete = [];
    for (const key of url.searchParams.keys()) {
      if (key.startsWith('filter.')) {
        keysToDelete.push(key);
      }
    }
    keysToDelete.forEach(key => url.searchParams.delete(key));
    
    window.location = url.toString();
  });

  // Remove individual filter
  document.querySelectorAll('[data-remove-filter]').forEach(btn => {
    btn.addEventListener('click', () => {
      const filterKey = btn.dataset.filterKey;
      const filterValue = btn.dataset.filterValue;
      
      const filters = getActiveFilters();
      
      if (filters[filterKey]) {
        filters[filterKey] = filters[filterKey].filter(v => v !== filterValue);
        if (filters[filterKey].length === 0) {
          delete filters[filterKey];
        }
      }
      
      window.location = buildFilterUrl(filters);
    });
  });

  // Clear all filters button in toolbar
  document.querySelector('.collection-toolbar__clear-filters')?.addEventListener('click', () => {
    const url = new URL(window.location);
    
    const keysToDelete = [];
    for (const key of url.searchParams.keys()) {
      if (key.startsWith('filter.')) {
        keysToDelete.push(key);
      }
    }
    keysToDelete.forEach(key => url.searchParams.delete(key));
    
    window.location = url.toString();
  });

  // chnaged by mokshes shah on 11 august, filter and sorting was not working

  // ===== Sort Handling =====
  // const sortSelect = document.getElementById('sort-select');
  
  // sortSelect?.addEventListener('change', () => {
  //   const url = new URL(window.location);
  //   url.searchParams.set('sort_by', sortSelect.value);
  //   url.searchParams.delete('page'); // Reset to page 1 when sorting
  //   window.location = url.toString();
  // });

  const sortSelectWrapper = document.querySelector('[data-select-name="sort_by"]');
  sortSelectWrapper?.addEventListener('select:change', (event) => {
    const value = event.detail?.value;

    if (!value) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  
  // ===== Load More / Infinite Scroll =====
  let loadMoreBtn = null;
  let isLoading = false;

  async function loadMoreProducts() {
    if (isLoading) return;
    
    const nextPageUrl = loadMoreBtn?.dataset.nextUrl;
    if (!nextPageUrl) return;
    
    isLoading = true;
    loadMoreBtn.classList.add('is-loading');
    loadMoreBtn.textContent = 'Loading...';
    
    try {
      const response = await fetch(nextPageUrl);
      const html = await response.text();
      
      // Parse the HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Get new products
      const newProducts = doc.querySelectorAll('#product-grid .product-card');
      const newLoadMoreBtn = doc.getElementById('load-more-btn');
      
      // Get reference to product grid
      const productGrid = document.getElementById('product-grid');
      
      // Append new products
      newProducts.forEach(product => {
        productGrid?.appendChild(product.cloneNode(true));
      });
      
      // Update load more button
      if (newLoadMoreBtn) {
        loadMoreBtn.dataset.nextUrl = newLoadMoreBtn.dataset.nextUrl;
        loadMoreBtn.textContent = 'Load More';
        loadMoreBtn.classList.remove('is-loading');
      } else {
        loadMoreBtn.remove();
      }
      
      // Reinitialize Lucide icons if needed
      if (typeof lucide !== 'undefined') {
        lucide.createIcons();
      }
      
      // Reinitialize product card behavior for newly added cards
      document.dispatchEvent(new CustomEvent('product-card:updated'));
      
    } catch (error) {
      console.error('Failed to load more products:', error);
      loadMoreBtn.textContent = 'Load More';
      loadMoreBtn.classList.remove('is-loading');
    }
    
    isLoading = false;
  }

  // Initialize Load More and Infinite Scroll after DOM is ready
  function initPagination() {
    loadMoreBtn = document.getElementById('load-more-btn');
    
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', loadMoreProducts);
    }

    // ===== Infinite Scroll =====
    const infiniteScrollTrigger = document.getElementById('infinite-scroll-trigger');
    
    if (infiniteScrollTrigger) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !isLoading) {
            loadMoreProducts();
          }
        });
      }, {
        rootMargin: '200px'
      });
      
      observer.observe(infiniteScrollTrigger);
    }
  }

  // Run pagination init when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPagination);
  } else {
    initPagination();
  }

  // ===== Filter Group Toggle (Details) =====
  document.querySelectorAll('.filter-group').forEach(group => {
    const summary = group.querySelector('.filter-group__header');
    const icon = group.querySelector('.filter-group__icon');
    
    group.addEventListener('toggle', () => {
      // Icon is handled by CSS ::after
    });
  });

  // ===== Price Range Inputs =====
  const priceMinInput = document.querySelector('[data-price-min]');
  const priceMaxInput = document.querySelector('[data-price-max]');
  
  function updatePriceFilter() {
    const min = priceMinInput?.value || '';
    const max = priceMaxInput?.value || '';
    
    // Update hidden inputs for form submission
    const hiddenMin = document.getElementById('filter-price-min');
    const hiddenMax = document.getElementById('filter-price-max');
    
    if (hiddenMin) hiddenMin.value = min ? min * 100 : '';
    if (hiddenMax) hiddenMax.value = max ? max * 100 : '';
  }
  
  priceMinInput?.addEventListener('change', updatePriceFilter);
  priceMaxInput?.addEventListener('change', updatePriceFilter);

  // ===== Color Swatch Selection =====
  document.querySelectorAll('.filter-color').forEach(swatch => {
    swatch.addEventListener('click', () => {
      swatch.classList.toggle('filter-color--selected');
      
      // Update associated checkbox
      const checkbox = swatch.querySelector('input[type="checkbox"]');
      if (checkbox) {
        checkbox.checked = swatch.classList.contains('filter-color--selected');
      }
    });
  });

  // ===== Initialize =====
  document.addEventListener('DOMContentLoaded', () => {
    // Initialize Lucide icons
    if (typeof lucide !== 'undefined') {
      lucide.createIcons();
    }
  });

})();

